import { proxy } from 'valtio'

export interface ListNodeScrollTarget {
  nodeId: string
  slotIndex: number
  timestamp: number
}

export const listNodeScrollStore = proxy<{ scrollTarget: ListNodeScrollTarget | null }>({
  scrollTarget: null
})

export function scrollToListNodeItem(nodeId: string, slotIndex: number) {
  listNodeScrollStore.scrollTarget = {
    nodeId,
    slotIndex,
    timestamp: Date.now()
  }
}
